import React, { useState, useCallback } from "react";
import { navigationSession } from "../../utils/constant";
import { Box, Flex } from "@chakra-ui/react";
import Header from "./Header";
import PropertyTypeSection from "./PropertyTypes";
import PropertyGrid from "./PropertyGrid";

const ExploreApartments = ({ isCompletionStatus = false }) => {
  // Initialize from session memory so state is restored on back-navigation
  const [selectedType, setSelectedType] = useState(navigationSession.apartmentSelectedType);

  const handleSelectType = useCallback((type) => {
    setSelectedType(type);
    navigationSession.apartmentSelectedType = type;
  }, []);

  return (
    <Box
      width={"100%"}
      mx="auto"
      backgroundColor="#f5f5f5"
      pt={isCompletionStatus ? 20 : 20}
      pb={isCompletionStatus ? 2 : 20}
      px={{ base: 4, md: "60px" }}
    >
      <Box mx="auto" maxW="100%">
        <Flex
          justifyContent={{ base: "center", md: "space-between" }}
          alignItems="center"
          flexDirection={{ base: "column", md: "row" }}
          mb={8}
        >
          <Header
            HeaderText={
              isCompletionStatus
                ? "searchBar.tab_new_projects"
                : "explore_types"
            }
            HeaderDescription={isCompletionStatus ? "" : "types_description"}
          />
          {!isCompletionStatus && (
            <PropertyTypeSection
              selectedType={selectedType}
              onSelectType={handleSelectType}
            />
          )}
        </Flex>
        <PropertyGrid
          selectedType={selectedType}
          isCompletionStatus={isCompletionStatus}
        />
      </Box>
    </Box>
  );
};

export default ExploreApartments;
